'use client';

import React from 'react';

export const MenuSkeleton: React.FC = () => {
    return (
        <li className="menu-item">
            <div className="menu-item-text skeleton"></div>
            <div className="menu-item-text skeleton"></div>
            <div className="menu-item-text skeleton"></div>
        </li>
    );
};
